<template>
  <div class="hidden-md-and-down">
    <v-btn
      to="/"
      text
      class="text-capitalize app-nav-link"
      prepend-icon="mdi-home"
      @click="scrollToTop"
    >
      Home
    </v-btn>
    <v-btn
      to="/benefits"
      text
      class="text-capitalize app-nav-link "
      prepend-icon="mdi-star"
      @click="scrollToTop"
    >
      Benefits
    </v-btn>
    <v-btn
      to="/solutions"
      text
      class="text-capitalize app-nav-link"
      prepend-icon="mdi-lightbulb-on"
      @click="scrollToTop"
    >
      Solutions
    </v-btn>
    <v-btn
      to="/vibes"
      text
      class="text-capitalize app-nav-link"
      prepend-icon="mdi-emoticon-happy"
      @click="scrollToTop"
    >
      Vibes
    </v-btn>
    <v-btn
      to="/positions"
      text
      class="text-capitalize app-nav-link"
      prepend-icon="mdi-human-male-board"
      @click="scrollToTop"
    >
      Careers
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'DesktopNav',
  methods: {
    scrollToTop() {
      // Force immediate scroll to top
      setTimeout(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }, 50);
    }
  }
};
</script>